import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle, subscribeToAuthChanges } from '../services/userService';

const SignIn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = subscribeToAuthChanges((user) => {
      if (user) {
        navigate('/interview');
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSignIn = async () => {
    setIsLoading(true);
    setError('');
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in error:', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8 p-8 bg-gray-900/30 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-800/50">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-400">
            Use your Google account to continue
          </p>
        </div>
        {error && (
          <div className="text-red-500 text-sm text-center">
            {error}
          </div>
        )}
        <div className="mt-8 flex justify-center">
          <button
            onClick={handleSignIn}
            disabled={isLoading}
            className={`bg-gray-900/30 backdrop-blur-sm px-4 py-2 rounded-lg hover:bg-gray-800/50 
              transition-all duration-300 flex items-center gap-2 border border-gray-800/50
              ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-transparent border-t-current rounded-full animate-spin" />
            ) : (
              <svg className="w-5 h-5 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  className="text-transparent"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  className="text-transparent"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  className="text-transparent"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  className="text-transparent"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
            )}
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent text-sm font-medium">
              {isLoading ? 'Signing in...' : 'Sign in with Google'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignIn; 